import jackpot from '@/api/front/jackpot-result'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetchResult(context, attrubutes = {}) {
    return jackpot.result({ params: {
        ...attrubutes
    }})
  },
  fetchWinner(context, attrubutes = {}) {
    return jackpot.winner({ params: {
        ...attrubutes
    }})
  }
}
